import { Outlet } from 'react-router-dom'
import { Card, CardContent, CardHeader } from '@racefront/shadcn-ui'
import { useAuthStore } from '../data/stores/auth.store'
import ContextBanner from '../components/context-banner'
import { useThemeStore } from '../data/stores/theme.store'

export default function AuthActionsLayout() {
  const { context } = useAuthStore()
  const { theme } = useThemeStore()

  return (
    <main
      id="main"
      className="relative min-h-dvh overflow-auto pb-[env(safe-area-inset-bottom)] sm:p-4 sm:px-6 sm:py-4"
    >
      <img
        className="fixed left-0 top-0 z-[-10] hidden h-screen w-full object-cover brightness-50 filter sm:block"
        src="/auth_bg.png"
        alt={'runners'}
      />
      <div className="mx-auto flex min-h-dvh max-w-lg flex-col items-center pb-4 sm:h-auto sm:pt-8">
        {context && (
          <div className="my-4">
            <ContextBanner context={context} />
          </div>
        )}
        <Card className="bg-background mb-4 w-full flex-1 rounded-none border-none sm:h-auto sm:flex-none sm:rounded-2xl sm:shadow-xl">
          <CardHeader>
            <img className="mx-auto" src={`logo_${theme}.png`} alt="Logo" width={160} height={160} />
          </CardHeader>
          <CardContent>
            <Outlet />
          </CardContent>
        </Card>
      </div>
    </main>
  )
}
